'use strict';
/**
 * Message sent by a peer to another one in order to suggest new
 * connection. This message is an answer to a MSuggest.
 */

var _classCallCheck = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var MSuggestBack =
/**
   * @param {object[]} sample The sample containing the identifier of peers
   * and their descriptor.
   */
function MSuggestBack(sample) {
  _classCallCheck(this, MSuggestBack);

  this.sample = sample;
  this.type = 'MSuggestBack';
};

module.exports = MSuggestBack;